/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioIntervalTimeUnit } from './InternalApiScenarioIntervalTimeUnit';
import {
    InternalApiScenarioIntervalTimeUnitFromJSON,
    InternalApiScenarioIntervalTimeUnitFromJSONTyped,
    InternalApiScenarioIntervalTimeUnitToJSON,
    InternalApiScenarioIntervalTimeUnitToJSONTyped,
} from './InternalApiScenarioIntervalTimeUnit';

/**
 * 
 * @export
 * @interface InternalApiPeriodicInterval
 */
export interface InternalApiPeriodicInterval {
    /**
     * 
     * @type {number}
     * @memberof InternalApiPeriodicInterval
     */
    interval: number;
    /**
     * 
     * @type {InternalApiScenarioIntervalTimeUnit}
     * @memberof InternalApiPeriodicInterval
     */
    timeUnit: InternalApiScenarioIntervalTimeUnit;
}



/**
 * Check if a given object implements the InternalApiPeriodicInterval interface.
 */
export function instanceOfInternalApiPeriodicInterval(value: object): value is InternalApiPeriodicInterval {
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('timeUnit' in value) || value['timeUnit'] === undefined) return false;
    return true;
}

export function InternalApiPeriodicIntervalFromJSON(json: any): InternalApiPeriodicInterval {
    return InternalApiPeriodicIntervalFromJSONTyped(json, false);
}

export function InternalApiPeriodicIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPeriodicInterval {
    if (json == null) {
        return json;
    }
    return {
        
        'interval': json['interval'],
        'timeUnit': InternalApiScenarioIntervalTimeUnitFromJSON(json['timeUnit']),
    };
}

export function InternalApiPeriodicIntervalToJSON(json: any): InternalApiPeriodicInterval {
    return InternalApiPeriodicIntervalToJSONTyped(json, false);
}

export function InternalApiPeriodicIntervalToJSONTyped(value?: InternalApiPeriodicInterval | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'interval': value['interval'],
        'timeUnit': InternalApiScenarioIntervalTimeUnitToJSON(value['timeUnit']),
    };
}

